'use client';

import { PropsWithChildren, useCallback } from 'react';
import { useDisclosure } from '~/app/_hooks/use-disclosure';
import { sendToFirebaseAnalytics } from '~/common/hooks/use-firebase-analytics';
import type { UserOverview } from '~/common/types/user-overview';
import { CommentsDetailDialogContainer } from '@app/(default-layout)/s/[storyId]/_containers/comments-detail-dialog-container';
import { Box } from '@styled-system/jsx';

type Props = PropsWithChildren<{
  storyId: string;
  storyTitle: string;
  author: UserOverview | undefined;
}>;

export const CommentsDetailContainer = ({ children, ...props }: Props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const handleOnClick = useCallback(() => {
    sendToFirebaseAnalytics('story_open_comment_dialog', {
      storyId: props.storyId,
    });
    onOpen();
  }, [onOpen, props.storyId]);

  return (
    <>
      <Box w="100%" onClick={handleOnClick}>
        {children}
      </Box>
      <CommentsDetailDialogContainer
        isOpen={isOpen}
        onOpenChange={({ open }) => {
          if (open) {
            onOpen();
          } else {
            onClose();
          }
        }}
        {...props}
      />
    </>
  );
};
